module.exports = __webpack_public_path__ + "img/Frame2455@2x.645ef370.png";